import tdcpMainSiteApi from "../axios/tdcpMainSiteInstance";

export const getNewsletterSubscribers = async () => {
  const url = `/api/newsletter-subscribers`;
  const response = await tdcpMainSiteApi.get(url);
  return response.data?.data || [];
};